<template>
  <div v-if="story != null && Object.keys(allImages).length > 1">
    <ion-grid v-if="allImages != null">
      <ion-row v-for="index in Math.ceil((Object.keys(allImages).length) / 3)" :key="'exploreKey-' + index">
        <ion-col size="4" class="explore-column">
          <div class="explore-thumb-container" v-if="showImage(allImages[(((index - 1) * 3))])">
            <img v-on:click="goToStory(allImages[(((index - 1) * 3))].id)"
              :class="'explore-thumb-pic photo-image-' + allImages[(((index - 1) * 3))].id + isSelected(allImages[(((index - 1) * 3))].id)"
              :id="'image_' + (index - 1) * 3" :src="path + '/piks/' + allImages[(((index - 1) * 3))].pik_name" />
            <div v-show="isVideo(allImages[(((index - 1) * 3))].type)"
              v-on:click="goToStory(allImages[(((index - 1) * 3))].id)" class="video-play">
              <ion-icon class="video-play-icon-sm" :icon="playCircle"></ion-icon>
            </div>
          </div>
          <div v-else-if="allImages[(((index - 1) * 3))] != null" class="explore-text-container"
            v-on:click="goToStory(allImages[(((index - 1) * 3))].id)">
            <div class="explore-text-div">
              <span style="font-size:0.9" v-html="allImages[((index - 1) * 3)].description"></span>
            </div>
          </div>
        </ion-col>

        <ion-col size="4" class="explore-column">
          <div v-if="showImage(allImages[((index - 1) * 3 + 1)])" class="explore-thumb-container">
            <img v-on:click="goToStory(allImages[(((index - 1) * 3 + 1))].id)"
              :class="'explore-thumb-pic photo-image-' + allImages[((index - 1) * 3 + 1)].id + isSelected(allImages[((index - 1) * 3 + 1)].id)"
              :id="'image_' + ((index - 1) * 3 + 1)" :src="path + '/piks/' + allImages[((index - 1) * 3 + 1)].pik_name" />
            <div v-show="isVideo(allImages[(((index - 1) * 3 + 1))].type)"
              v-on:click="goToStory(allImages[(((index - 1) * 3 + 1))].id)" class="video-play">
              <ion-icon class="video-play-icon-sm" :icon="playCircle"></ion-icon>
            </div>
          </div>
          <div v-else-if="allImages[(((index - 1) * 3 + 1))] != null" class="explore-text-container"
            v-on:click="goToStory(allImages[(((index - 1) * 3 + 1))].id)">
            <div class="explore-text-div">
              <span v-html="allImages[((index - 1) * 3 + 1)].description"></span>
            </div>
          </div>
        </ion-col>
        <ion-col size="4" class="explore-column">
          <div v-if="showImage(allImages[((index - 1) * 3 + 2)])" class="explore-thumb-container">
            <img v-on:click="goToStory(allImages[(((index - 1) * 3 + 2))].id)"
              :class="'explore-thumb-pic photo-image-' + allImages[((index - 1) * 3 + 2)].id + isSelected(allImages[((index - 1) * 3 + 2)].id)"
              :id="'image_' + ((index - 1) * 3 + 2)" :src="path + '/piks/' + allImages[((index - 1) * 3 + 2)].pik_name" />
            <div v-show="isVideo(allImages[(((index - 1) * 3 + 2))].type)"
              v-on:click="goToStory(allImages[(((index - 1) * 3 + 2))].id)" class="video-play">
              <ion-icon class="video-play-icon-sm" :icon="playCircle"></ion-icon>
            </div>
          </div>
          <div v-else-if="allImages[(((index - 1) * 3 + 2))] != null" class="explore-text-container"
            v-on:click="goToStory(allImages[(((index - 1) * 3 + 2))].id)">
            <div class="explore-text-div">
              <span v-html="allImages[((index - 1) * 3 + 2)].description"></span>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-infinite-scroll @ionInfinite="loadMorePosts($event)" id="infinite-scroll">
      <ion-infinite-scroll-content loading-spinner="bubbles" :loading-text="$t('loadmessage.loadingexplore')">
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </div>
</template>

<script>
import { IonCol, IonGrid, IonRow, IonIcon, loadingController, IonInfiniteScroll, IonInfiniteScrollContent  } from '@ionic/vue';
import { playCircle, arrowBackCircle } from 'ionicons/icons';
import getEnv from '@/utils/env';

export default {
  name: 'ShowMoreContainer',
  props: {
    story: { Object, default: null },
    imageSelected: { Number, default: 0 },
    isModal: { Boolean, default: false }
  },
  emits: ['update:imageSelected'],
  components: {
    IonCol, IonGrid, IonRow, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent 
  },
  setup() {
    return { playCircle, arrowBackCircle }
  },
  data() {
    return {
      loadingIndicator: '',
      path: getEnv('AWS_URL') + getEnv('PHOTO_BUCKET'),
      allImages: [],
      nextPage: false
    }
  },
  async mounted() {
    for (let x in this.story.allimages) {
      this.allImages.push(this.story.allimages[x]);
    }
    this.allImages.reverse();
    //this.getExplore();
  },
  methods: {
    async goToStory(id) {
      //console.log(this.isModal, 'isModal');
      if (this.isModal || this.nextPage) {
        this.$emit('update:imageSelected', id);
        this.$router.push({name: 'story', params: { imageid: id } });
      } else {
        this.$emit('update:imageSelected', id);
      }
    },
    async loadMorePosts(event) {
      let totalImagesLoaded = this.allImages.length;
      let totalImages = this.story.totalvids + this.story.totalpiks;
      //console.log(totalImages, 'total images');
      //console.log(totalImagesLoaded, 'total images loaded');
      if (totalImages <= totalImagesLoaded) {
        event.target.complete();
      } else {
        let finished = await this.pagingOptions(totalImagesLoaded, totalImages, 'back');
        if (finished) {
          event.target.complete();
          this.nextPage = true;
          //console.log(finished, 'finished');
        }
      }
    },
    async pagingOptions(totalImagesLoaded, totalImages, direction) {
      var newPage = 0;
      var newTotal = 0;
      let currentIndex = this.allImages[totalImagesLoaded - 1].current_index;
      //console.log(currentIndex, 'current index');
      if (direction == 'back') {
        newPage = currentIndex - 10;
        if (newPage < 0) {
          newPage = 0;
        }
        newTotal = 10;
        if (currentIndex < 10) {
          newTotal = currentIndex;
        }
      }

      //console.log("get next page: " + "pikstream/pagev2?totalList=" + newTotal + "&currentPage=" + newPage + "&id=" + this.story.piklist_id);
      let response = await this.$store.dispatch("pikstream/pageStory", {
        url: "pikstream/pagev2?totalList=" + newTotal + "&currentPage=" + newPage + "&id=" + this.story.piklist_id,
        streamType: 'postsView'
      });

      if (response) {
        if (response.error != undefined) {
          console.log('Error: ' + response.error);
        } else {
          let imageSize = this.allImages.length;
          let arrayReverse = response.allimages.reverse();
          for (let x in arrayReverse) {
            this.allImages[imageSize] = arrayReverse[x];
            imageSize++;
          }
          return direction;
        }
      }
    },
    async presentLoading() {
      this.loadingIndicator = await loadingController
        .create({
          cssClass: 'loading-class',
          message: this.$t('loadmessage.updating'),
        });
      await this.loadingIndicator.present();
    },
    isVideo(type) {
      let videoType = false
      if (type != null) {
        if (type == 2) videoType = true;
      }
      return videoType;
    },
    showImage(storyImage) {
      let canShowImage = true;
      if (storyImage != null) {
        if (storyImage.type == 3) {
          if (storyImage.link_image == '') {
            canShowImage = false;
          }
        }
      } else {
        canShowImage = false;
      }
      return canShowImage;
    },
    isSelected(id) {
      let style = '';
      //console.log(this.imageSelected, 'image selected');
      if (id == this.imageSelected) {
        style = ' thumb-selected';
      } else if (id == this.$route.params.imageid && this.imageSelected == 0) {
        style = ' thumb-selected';
      }
      return style;
    }
  }
}
</script>

<style scoped>
.explore-column {
  --ion-grid-column-padding: 1.0px;
}
</style>
 